import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/es/integration/react'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { ThemeProvider } from 'emotion-theming'
import { getCurrentAppData } from './utils/fractalApps'

import './i18n'
import App from './app'
import configureStore from './store/configureStore'

import './index.style'

const { persistor, store } = configureStore()

const onBeforeLift = () => {
  // take some action before the gate lifts
}

const appTheme = {
  primaryColor: getCurrentAppData() ? getCurrentAppData().theme.primaryColor : '#878787'
}

const muiTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#878787'
    },
    secondary: {
      main: '#878787'
    },
    text: {
      main: '#464646'
    }
  }
})

const renderApp = NextApp => {
  render(
    <Provider store={store}>
      <PersistGate
        loading={null}
        onBeforeLift={onBeforeLift}
        persistor={persistor}
      >
        <MuiThemeProvider theme={muiTheme}>
          <ThemeProvider theme={appTheme}>
            <NextApp />
          </ThemeProvider>
        </MuiThemeProvider>
      </PersistGate>
    </Provider>,
    document.getElementById('app')
  )
}

renderApp(App)
